/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Nav_CapabilitiesInputs */

const en_landing_nav_capabilities = /** @type {(inputs: Landing_Nav_CapabilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capabilities`)
};

/**
* | output |
* | --- |
* | "Capabilities" |
*
* @param {Landing_Nav_CapabilitiesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_nav_capabilities = /** @type {((inputs?: Landing_Nav_CapabilitiesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Nav_CapabilitiesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_nav_capabilities(inputs)
});